import React from 'react';
import banner from '../../assets/banner-removebg-preview.png';
import './Banner.css';
import TypeWriterEffect from 'react-typewriter-effect';
const Banner = () => {
    return (
        <div className="container mt-5 mb-5">

            <div class="row d-flex justify-content-between align-items-center gy-3">


                <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                    <h1 data-aos="zoom-in-out"
                        data-aos-easing="ease-in-back"
                        data-aos-delay="0"
                        data-aos-offset="0"
                        data-aos-duration="1000" className='fw-semibold lh-base fs-1'>Making the most of the <br /> ever-growing <br />
                    </h1>

                    <h1 className='red fw-semibold lh-base'>   <TypeWriterEffect

                        startDelay={1000}
                        cursorColor="#rgba(238, 66, 72, 1)"
                        multiText={[
                            'Informational Technology',
                            'Informational Technology',
                            'Informational Technology',
                            'Informational Technology',
                        ]}
                        multiTextDelay={1000}
                        typeSpeed={60}
                    /></h1>
                    <p data-aos="zoom-in-out"
                        data-aos-easing="ease-in-back"
                        data-aos-delay="0"
                        data-aos-offset="0"
                        data-aos-duration="500" >Managed by a team professional experts with extensive experiance and impressive track records</p>

                    <p data-aos="zoom-in-out"
                        data-aos-easing="ease-in-back"
                        data-aos-delay="0"
                        data-aos-offset="0"
                        data-aos-duration="500" className='red_button btn rounded-1 text-white p-2 px-3'>Read More</p>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                    <img src={banner} class="d-block w-100" data-aos="fade-left" data-aos-duration="2000" alt="..." />
                </div>
            </div>

        </div>
    );
};

export default Banner;